// src/components/CookieConsent/index.js
import CookieConsent from './CookieConsent';
export default CookieConsent;